import React, { useRef } from 'react';
import { Helmet } from 'react-helmet';
import Carouselhome from '../home/carousel-home';
import Header from '../header';
import Footer from '../footer';
import Sidebar from '../sidebar';
import Megamenu from '../megamenu';
import Mobsidebar from '../mobile-sidebar';
import IBC1 from '../../images/Project_Images/IBC-6.webp';
import IBC2 from '../../images/Project_Images/IBC-4.webp';
import IBC3 from '../../images/Project_Images/IBC-5.webp';
import ScrollToTopButton from '../ScrollButton';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from 'react-slick';
function ProjectIBC() {
    const sliderRef = useRef(null);

    const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 3000,
    };

    const goToPrev = () => {
        sliderRef.current.slickPrev();
    };

    const goToNext = () => {
        sliderRef.current.slickNext();
    };

    return (
        <>
            <Helmet>
                <title>About Our IBC Knowledge Centre Acoustics Project</title>
                <meta name="description" content="" />
                <meta property="og:title" content="IBC Knowledge Centre" />
                <meta property="og:description" content="We supplied and installed Acoustic Wooden Door – Double Leaf with White Laminate finish." />
                <meta property="og:image" content="https://www.acousticalsurfaces.in/images/IBC-6.webp" />
                <meta property="og:locale" content="en-in" />
                <link rel="canonical" href="https://www.acousticalsurfaces.in/acoustic-projects/project-ibc" />
                <link rel="alternate" href="https://www.acousticalsurfaces.in/acoustic-projects/project-ibc" hreflang="en-in" />
                <meta name="geo.placename" content="India" />
                <meta http-equiv="content-language" content="IN" />
                <meta name="geo.region" content="india" />
            </Helmet>
            <Header />
            <section className="content">
                <div className="container">
                    <div className="row">
                        <div className="col-sm-3 sidemenu">
                            <Sidebar />
                        </div>
                        <div className="col-sm-9 product-page nopaddding">
                            <div className="container">
                                <div className="megamenu">
                                    <Megamenu />
                                </div>
                            </div>
                            <div className="image-slider pro-content">
                                <div id="caption-slide" className="slider-container">
                                    <div className="slider">
                                        <Slider {...settings} ref={sliderRef}>
                                            <div className="slide">
                                                <img src={IBC1} className="img-fluid" alt="IBC1" />
                                            </div>
                                            <div className="slide">
                                                <img src={IBC2} className="img-fluid" alt="IBC2" />
                                            </div>
                                            <div className="slide">
                                                <img src={IBC3} className="img-fluid" alt="IBC3" />
                                            </div>
                                        </Slider>
                                    </div>
                                    <div className="switch slider-arrow" id="prev" onClick={goToPrev} style={{ backgroundColor: "transparent" }}><span>&#10094;</span></div>
                                    <div className="switch slider-arrow" id="next" onClick={goToNext} style={{ backgroundColor: "transparent" }}><span>&#10095;</span></div>
                                </div>
                            </div>
                            <div className="row pro-content">
                                <div className="col-sm-12 writeup">
                                    <h3>IBC Knowledge Centre</h3>
                                    <p className="note">Location: Bangalore</p>
                                    <p><strong>About IBC Knowledge Centre Acoustic Project</strong>
                                        <br />Ather Energy is a leading Indian electric vehicle company headquartered @IBC KNOWLEDGE PARK Bengaluru, known for its innovation in smart and connected electric scooters. With a strong focus on sustainability and advanced technology, Ather has become a pioneer in redefining urban mobility across India.<br />
                                    </p>
                                    <p>
                                        <strong>Our Scope</strong>
                                        <br />For Ather Energy’s corporate facility at IBC Knowledge Park, Bengaluru, we supplied and installed Acoustic Wooden Door – Double Leaf with White Laminate finish. The solution was designed to provide superior sound insulation while maintaining a clean, modern aesthetic that complements the workspace environment.
                                    </p>
                                    <br />
                                    <hr />
                                </div>
                            </div>
                            <div className="col-sm-12 ourprojects">
                                <h5>OUR PROJECTS</h5>
                                <p style={{ margin: "15px" }}><b>We deliver high-performance acoustic solutions with precision, innovation, and quality craftsmanship.
                                    Explore our recently completed projects that reflect our expertise across diverse spaces.</b></p>
                                <div id="mixedSlider">
                                    <div className="MS-content">
                                        <Carouselhome />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='mobsidebar'>
                        <div className="col-sm-12">
                            <div className="container">
                                <div className="row">
                                    <Mobsidebar />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <ScrollToTopButton />
            </section>
            <Footer />
        </>
    )
}

export default ProjectIBC